import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as ReportsAPI from '../../api/Attendance/reports';
import { UsersStatusesReportInput } from '../../models/attendance';
import AppIcon from '../AppIcon';
import Shared from './Shared';

interface IProps {
    userId?: string;
    match?: { params: { format: string, from: string, to: string } };
    history?: any;
    t?: any;
}

interface IState {
    invalidURL: boolean;
}

class UsersStatusesReport extends Component<IProps, IState> {
    state = {
        invalidURL: false,
    };

    async componentDidMount() {
        await this.downloadFile();
    }

    async downloadFile() {
        try {
            if (this.props.match) {
                const dateToSplit = this.props.match?.params.to.split('-');
                const dateFromSplit = this.props.match?.params.from.split('-');
                const to = new Date(
                    parseInt(dateToSplit[2]),
                    parseInt(dateToSplit[0]) - 1,
                    parseInt(dateToSplit[1])
                );
                const from = new Date(
                    parseInt(dateFromSplit[2]),
                    parseInt(dateFromSplit[0]) - 1,
                    parseInt(dateFromSplit[1])
                );

                const format = this.props.match.params.format;
                const reportInput = {
                    userId: this.props.userId,
                    to: to,
                    from: from,
                } as UsersStatusesReportInput;
                await ReportsAPI.exportUsersStatuses(reportInput, format);
            }
        } catch (ex) {
            this.setState({ invalidURL: true });
        }
    }

    render() {
        const { t } = this.props;
        return (
            <>
                {this.state.invalidURL ? (
                    <div className="flex justify-center p-4">
                        <div role="alert" className="flex items-center gap-2 rounded-md border border-destructive/50 bg-destructive/10 p-3 text-sm text-destructive">
                            <AppIcon name="AlertCircle" size={16} />
                            {t('Invalid Report')}
                        </div>
                    </div>
                ) : (
                    <Shared downloadFile={() => this.downloadFile()} />
                )}
            </>
        );
    }
}

const mapStateToProps = (state: any) => ({
    userId: state.user.userId,
});

export default connect(mapStateToProps)(withTranslation()(UsersStatusesReport));
